module.exports = __webpack_public_path__ + "static/media/tick.31e7db66.png";